document.addEventListener("DOMContentLoaded", () => {
  class subscriptionForm extends HTMLElement {
    constructor() {
      super();
      this.variantData = JSON.parse(this.querySelector("#subscription-json").textContent);
      this.variants = this.querySelectorAll(".subscription__variant");
      this.plans = this.querySelectorAll(".subscription__selling-plan");
      this.customPlan = this.querySelector(".subscription__selling-custom-plan");
      this.currentSellingType = this.querySelector(".subscription-tab.active").dataset.sellingType;
      this.initInputs();
      this.plans.forEach((plan) =>
        plan.addEventListener("click", this.changePlan.bind(this, plan))
      );
      this.variants.forEach((variant) =>
        variant.addEventListener("click", this.changeVariant.bind(this, variant))
      );
      this.querySelectorAll(".subscription-tab").forEach((tab) => {
        tab.addEventListener("click", this.changeType.bind(this, tab));
        if (tab.dataset.sellingType === "subscribe") {
          this.subscriptionTab = tab;
        }
      });
      this.customPlan?.addEventListener("click", this.initCustomPlan.bind(this));
    }

    changeType(tab) {
      this.querySelectorAll(".subscription-tab").forEach((subtab) => {
        subtab.classList.remove("active");
      });
      tab.classList.add("active");
      this.currentSellingType = tab.dataset.sellingType;
      if (this.currentSellingType === "once") {
        this.sellingPlanInput.value = "";
        this.setAttribute("data-selling-type", "once");
      } else {
        this.removeAttribute("data-selling-type");
        this.plans.forEach((plan) => {
          if (plan.classList.contains("active"))
            this.sellingPlanInput.value = plan.dataset.sellingPlanId;
        });
      }

      this.updatePrice();
    }

    updatePrice() {
      this.variants.forEach((variant, index) => {
        const price = variant.querySelector(".subscription__variant-price");
        const discount = variant.querySelector(".subscription__variant-discount");
        const compare = variant.querySelector(".subscription__variant-compare_price");

        let variantData = this.variantData[variant.dataset.variantId][this.currentSellingType];
        if (this.currentSellingType === "subscribe") {
          variantData = variantData[this.sellingPlanInput.value];
        }

        if (index === 0 && this.currentSellingType === "subscribe") {
          this.subscriptionTab.innerHTML = variantData.tab_text;
        }

        console.log(variantData);

        price.innerHTML = variantData.price;
        if (variantData.discount != "") {
          discount.innerHTML = variantData.discount;
          discount.classList.remove("hidden");
        } else {
          discount.classList.add("hidden");
        }

        if (!compare) return;

        compare.innerHTML = variantData.compare_at_price;
        compare.classList.toggle("hidden", variantData.price === variantData.compare_at_price);
      });
    }

    changeVariant(currentVariant) {
      this.productVariantInput.value = currentVariant.dataset.variantId;
      this.variants.forEach((variant) => variant.classList.remove("active"));
      currentVariant.classList.add("active");
    }

    changePlan(currentPlan) {
      this.sellingPlanInput.value = currentPlan.dataset.sellingPlanId;
      this.plans.forEach((plan) => plan.classList.remove("active"));
      currentPlan.classList.add("active");
      this.updatePrice();
    }

    initCustomPlan() {
      this.classList.add("custom-plan-open");
      this.controlButtons = this.querySelectorAll("[data-control-plan]");
      this.currentPlanId = 0;
      this.changePlan(this.plans[0]);
      this.controlButtons.forEach((button) => {
        button.addEventListener("click", this.swipePlan.bind(this, button));
      });
    }

    swipePlan(button) {
      this.controlButtons.forEach((controlButton) => {
        if (controlButton.dataset.controlPlan != button.dataset.controlPlan)
          controlButton.classList.remove("disabled");
      });

      const step = button.dataset.controlPlan == "next" ? 1 : -1;
      if (this.currentPlanId + step >= this.plans.length || this.currentPlanId + step < 0) {
        return;
      }
      if (this.currentPlanId + step < this.plans.length || this.currentPlanId + step > 0) {
        this.currentPlanId += step;
      }
      if (this.currentPlanId >= this.plans.length - 1 || this.currentPlanId <= 0) {
        button.classList.add("disabled");
      }

      this.plans.forEach((variant) => {
        variant.classList.add("hidden");
        variant.classList.remove("show");
      });
      this.plans[this.currentPlanId].classList.remove("hidden");
      this.plans[this.currentPlanId].classList.add("show");
      this.changePlan(this.plans[this.currentPlanId]);
    }

    initInputs() {
      const productForm =
        this.closest(".product-single__meta").querySelector(".product-single__form");
      const inputs = `<input type="hidden" id="subscription_selling_plan" name="selling_plan" value="${this.dataset.sellingPlanId}">
                                <input id="subscription_product_id" type="hidden" name="id" value="${this.dataset.variantId}">`;
      if (!productForm) {
        return;
      }
      productForm.innerHTML += inputs;
      this.sellingPlanInput = productForm.querySelector("#subscription_selling_plan");
      this.productVariantInput = productForm.querySelector("#subscription_product_id");
    }
  }

  customElements.define("subscribe-form", subscriptionForm);
});
